// Working Days
const footerWorkingDaysElem = document.querySelector('.site-footer__working-days');

if (footerWorkingDaysElem) {
  const updateActiveDay = () => {
    const todayEl = footerWorkingDaysElem.querySelector('.working-days__item.is-active');
    if (!todayEl) return;

    const parent = todayEl.parentElement;
    if (!parent) return;

    const parentRect = parent.getBoundingClientRect();
    const itemRect = todayEl.getBoundingClientRect();

    const isVisible = itemRect.left >= parentRect.left && itemRect.right <= parentRect.right;

    if (windowWidth() < breakpointSm) {
      const parentScrollLeft = parent.scrollLeft;
      const parentCenter = parentRect.left + parentRect.width / 2;
      const itemCenter = itemRect.left + itemRect.width / 2;

      const scrollTo = parentScrollLeft + (itemCenter - parentCenter);

      parent.scrollTo({ left: scrollTo, behavior: 'smooth' });
    } else if (!isVisible) {
      todayEl.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }
  };

  const axiosUpdateFooterWeeklyWorkingSchedule = async () => {
    const action = 'updateFooterWeeklyWorkingSchedule';

    try {
      const { data } = await axios.post(localData.siteURL, {
        action,
        nonce: await getNonceForAction(action),
      });

      if (data?.data?.html_weekly_schedule) {
        footerWorkingDaysElem.innerHTML = data.data.html_weekly_schedule;
        setTimeout(updateActiveDay, 300);
      }
    } catch (err) {
      console.error(err);
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    axiosUpdateFooterWeeklyWorkingSchedule();
  });

  window.addEventListener('resize', () => setTimeout(updateActiveDay, 300));
}
